import { Injectable } from "@angular/core";
import { IFilter } from "../../model/filter";
import { LocalStorageService } from "./local-storage.service";

@Injectable()
export class FiltersService {
  constructor(private localStorageService: LocalStorageService) {}

  public createFilterWithObject(filters: IFilter[], filter: IFilter, containerId) {
    filters.push(filter);
    const storedFilters = {
      filters,
      containerId
    }
    this.localStorageService.setItem("filters", storedFilters);
  }

  public createFiltersWithObjects(
    filters: IFilter[],
    newfilters: IFilter[],
    containerId,
    keepInMemory: boolean = true
  ) {
    if (!newfilters || newfilters.length === 0) 
      return filters;
    if (!filters || filters.length === 0)
      filters = [];
    
    filters.push(...newfilters);
    if (keepInMemory) {
      const storedFilters = {
        filters,
        containerId
      }
      this.localStorageService.setItem("filters", storedFilters);
    }
    return filters;
  }

  public forceUpdateFilter(
    filters: IFilter[],
    key: number,
    newFilter: IFilter, 
    containerId
  ) {
    filters[key] = newFilter;
    const storedFilters = {
      filters,
      containerId
    }
    this.localStorageService.setItem("filters", storedFilters);
  }

  public forceUpdateFilters(
    filters: IFilter[],
    indexes: number[],
    newFilters: IFilter[],
    keepInMemory: boolean = true, 
    containerId
  ) {
    filters = filters.filter((filter, index) => indexes.indexOf(index) < 0);
    filters.push(...newFilters);
    if (keepInMemory) {
      const storedFilters = {
        filters,
        containerId
      }
      this.localStorageService.setItem("filters", storedFilters);
    }
    return filters;
  }

  public removeFilter(filters: IFilter[], key: string, containerId) {
    const index = filters.findIndex((filter) => filter.parameter.name === key);
    this.removeFilterByIndex(filters, index, containerId);
  }

  public removeFilterByIndex(filters: IFilter[], index: number, containerId) {
    if (index >= 0) {
      filters.splice(index, 1);
    }
    const storedFilters = {
      filters,
      containerId
    }
    this.localStorageService.setItem("filters", storedFilters);
  }

  public removeFiltersByIndexes(filters: IFilter[], indexes: number[], containerId) {
    filters = filters.filter((f, i) => indexes.indexOf(i) < 0);
    const storedFilters = {
      filters,
      containerId
    }
    this.localStorageService.setItem("filters", storedFilters);
    return filters;
  }

  // Called each time container changes
  public initScenariosFilters() {
    return this.localStorageService.getItem("filters") ;
  }
}
